import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { DropdownMenuItem } from "@/core/components/ui/dropdown-menu";
import { toast } from "@/core/components/ui/toast";
import { isProductEnabled } from "@/business/product-access";
import { useStartQuickbooksOauth } from "@/business/quickbooks-query";
import { useBusiness } from "@/core/business";
import { useBusinessProducts } from "@/core/business/use-business-products";
import { useGetMyUser } from "@/user/query";
import { isAdminOrOwner } from "@/user/utils";

const QuickbooksDropdownItem = () => {
  const { data: userInfo } = useGetMyUser();
  const { businessId, selectedBusiness } = useBusiness();
  const { settings } = useBusinessProducts();
  const enableAp = isProductEnabled(settings, "accounts_payable");
  const { mutateAsync: startQuickbooksOauth, isPending: isConnectingQb } =
    useStartQuickbooksOauth(businessId);

  const showQuickbooksItem =
    enableAp &&
    !!selectedBusiness?.service_titan_enabled &&
    isAdminOrOwner(userInfo?.role);
  const isQuickbooksConnected = !!selectedBusiness?.quickbooks_connected;

  const handleConnectQuickbooks = async () => {
    if (!businessId) {
      toast.error("Business not found.");
      return;
    }

    try {
      const data = await startQuickbooksOauth();
      window.location.href = data.authorize_url;
    } catch (error) {
      toast.error("Unable to start QuickBooks connection.", {
        description:
          error instanceof Error ? error.message : "Please try again.",
      });
    }
  };

  if (!showQuickbooksItem) {
    return null;
  }

  return (
    <DropdownMenuItem
      disabled={isQuickbooksConnected || isConnectingQb}
      onSelect={(event) => {
        if (isQuickbooksConnected) {
          return;
        }

        event.preventDefault();
        void handleConnectQuickbooks();
      }}
      className="justify-between"
    >
      <span>Connect QuickBooks</span>
      {isQuickbooksConnected && (
        <CheckCircleIcon aria-label="Connected" className="text-green-60" />
      )}
    </DropdownMenuItem>
  );
};

export default QuickbooksDropdownItem;
